import { dateToStringFormat, stringToDateFormat } from 'utils';
import { CHART_TEMLATES } from '../../Template';
import DatePickerCustom from 'components/common/DatePickerCustom/DatePickerCustom';

const IntroductionFrame = ({ title, onDateChange, date, isAllowedEdit, template = 0 }: any) => {
  return (
    <div>
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          marginBottom: 6,
          paddingRight: 6,
          fontWeight: 'bold',
        }}
      >
        <div style={{ marginRight: '10px' }}>{title}</div>
        <div>
          <div style={{ maxWidth: '110px' }}>
            <DatePickerCustom
              value={date}
              key={date ? dateToStringFormat(date, 'yyyy-MM-dd') : 'null'}
              onChange={(date: Date) => onDateChange(date)}
              onBlur={(date: any) => {
                const formatDate = stringToDateFormat(date);
                if (formatDate) {
                  onDateChange(formatDate);
                }
              }}
              disabled={!isAllowedEdit}
            />
          </div>
        </div>
        <div style={{ marginLeft: '10px' }}> 改訂</div>
      </div>

      {CHART_TEMLATES[template].displayComponent}
    </div>
  );
};

export { IntroductionFrame };
